// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"28886e1a","455":"e89199d1"}[chunkId] + ".chunk.js";
};